export const lang = {
  BarOther: {
    home: 'Home',
    service: 'Service',
    quality: 'Quality Control',
    rkkw9t: 'Container Loading',
    oww1lo: 'Vendor Assessment',
    vwiq99: 'New Product Development',
    fuaoau: 'User Guide',
    q618ep: 'Contact',
    iqp9rr: 'Get Started',
    b2xprb: 'Language',
  },
  FooterOther: {
    zs3eck: 'Get service on the phone',
    ktb2ur: 'Minder Inspection',
    '6yyjjc': 'Works with Minder, Minder Works',
    re5sad: 'Minderworks  All Rights Reserved',
    usnxbi: 'Contact us',
  },
  main: {
    '1dt1j2': 'Keep Your Product Qualified',
    quailty:
      ' When it                                                             comes to quality, we think                                                             of every single                                                             piece',
    pczd9p: 'Start Now',
    '7rbwz7':
      ' Minder Inspection is a third-party inspection platform. Minder provide                             quality control services                             such as product inspection, vendor auditing, Loading supervision etc. which help customers                             optimizing quality system.&nbsp; Our smart monitoring system brings highly efficient quality                             tracking experiences.',
    d5ccl3: 'What we offer',
    hb3x95:
      ' Minder offers you a New way to tracking quality control process, By providing excellent                             inspection services, we are aiming to get your trade done much more easier than you ever                             imagined before.',
    ss10g8: 'Product Quality Control',
    jspb3m: 'More',
    u44avv: 'Vendor Assessment',
    cpnavt: 'Container Loading',
    xf74pb: 'Product Development',
    qlu4ej: 'What we can bring you',
    '1bfizf': 'Quality Control Team',
    me37mm:
      'Minder Inspectors are with professional inspection capability, the experienced team will be able to provide excellent quality control services.',
    cb2q1j: 'Anytime,Anywhere',
    var86x:
      'Minder’s service covers most region of China. There’s no worry about the distance and time. You are able to access our on-line system and view report',
    nwz8j7: 'Cost efficient',
    rto9zc:
      'Travel to the factory site may cost you more on flights and accommodations. With our service, there’s no extra cost to worry about.',
    wkmsf4: 'Data driven Report',
    '25f6ak':
      'Our report is  based on real data collected from the on-site check which Allows you to get more precise data during the measurement and on-site tests',
    p4586r: "Let's get start",
    jtdq0u: 'Get Started',
    f3oiph:
      'Simply log into our Minder online booking system and input the basic information  to submit the booking',
    v3ojm4: 'Want to check our sample report?',
    b1u9xm: 'Get a Sample report',
    okn6an: 'Enter your email here *',
    u5asdi: 'Sign Up',
  },
  quailty: {
    '0mal0f': ' Quality control service',
    po356y: 'During Production Inspection',
    '26c0pu':
      'During Production Inspection is performed when 30%- 50% goods are finished and                                             packed. This inspection validates the initial production process has been                                             maintained and that goods being produced continue to meet quality requirements.                                             In the case of new raw materials, new operators, production lines or                                             specification changes, this service can assess if requirements are being met                                             during production.',
    '5k1ybr': 'Pre-Shipment Inspection',
    ttza9v:
      "Pre-shipment Inspection (Final Inspection) is a most effective way that confirms                                             the whole shipment's quality level. It normally requires the production to be                                             100% complete and at least 80% of goods to be packed into cartons. Quality                                             engineers will do the random sampling and inspect strictly according to the AQL                                             standards.",
    okc6nf: 'Multiple Categories',
    wssl3q:
      ' Tool, Toy, Furniture, Hardware, Decoration, Personal care, Outdoor equipment etc.',
    kb9sl6: 'Groceries',
    rgkx6g: 'fabric, textile and raw material, home furnishing etc.',
    d94vs5: 'Fabric & Textiles',
    qtay9t: 'Garment, Accessory, Bag, Luggage, Shoe etc.',
    wdw9wg: 'Garment & Bags',
    dq5hgi:
      'Home electrical equipment, Electronics, Lights, Electronic accessory etc.',
    fndilq: 'Electronics & Electrical Equipment',
    yovmva: ' Amazing Price',
    h4zdms: 'Get Plan',
  },
  container: {
    '0mal0f': ' Quality control service',
    po356y: 'During Production Inspection',
    '26c0pu':
      'During Production Inspection is performed when 30%- 50% goods are finished and                                             packed. This inspection validates the initial production process has been                                             maintained and that goods being produced continue to meet quality requirements.                                             In the case of new raw materials, new operators, production lines or                                             specification changes, this service can assess if requirements are being met                                             during production.',
    '5k1ybr': 'Pre-Shipment Inspection',
    ttza9v:
      "Pre-shipment Inspection (Final Inspection) is a most effective way that confirms                                             the whole shipment's quality level. It normally requires the production to be                                             100% complete and at least 80% of goods to be packed into cartons. Quality                                             engineers will do the random sampling and inspect strictly according to the AQL                                             standards.",
    okc6nf: 'Multiple Categories',
    wssl3q:
      ' Tool, Toy, Furniture, Hardware, Decoration, Personal care, Outdoor equipment etc.',
    kb9sl6: 'Groceries',
    rgkx6g: 'fabric, textile and raw material, home furnishing etc.',
    d94vs5: 'Fabric & Textiles',
    qtay9t: 'Garment, Accessory, Bag, Luggage, Shoe etc.',
    wdw9wg: 'Garment & Bags',
    dq5hgi:
      'Home electrical equipment, Electronics, Lights, Electronic accessory etc.',
    fndilq: 'Electronics & Electrical Equipment',
    yovmva: ' Amazing Price',
    h4zdms: 'Get Plan',
  },
  vendor: {
    '2ikbjo': 'Vendor Assessment',
    c4qsgh: 'Want to know more about your potential supplier?',
    ja3s8r:
      'Optimizing your vendor manangement, we offer you a better solution!',
    xuz603: '清晰识别供应商',
    zxy9bc: 'Real data suppot the right decision',
    yewaw8:
      'You are able to access to your potential vendor in a much more efficient way. We present detailed data and files of the vendor which will be quite crucial to your decision.',
    qnzcvs: 'Get a close look of your vendor',
    v4f2fg:
      'Industries varies from each other. Expertise is required in dealing with certain business. We analyze and assess your vendor in a particular way.',
    '2lrzjb': 'We know what you care most',
    '4ez0fi':
      'With our flexible order system, your special requirements will be well noticed. You are able to grab the details that you care most.',
    '3a65tn': 'Key Features',
  },
  product: {
    asifsf: 'New Product Development',
    '5e2vvj':
      'Normally it takes much energy and cost on communications between factory team and the R&D                                 team during the new product development. we are here to help!',
    '4ebm8s': 'Keep the Launch schedule on track',
    gsfl38:
      'When you start a new project, you might need to make several mockups or prototypes. normally the                             reviews will get back and forth and it takes a long time to deliver samples. In many cases, it                             will probably create launch delay.',
    nf0053:
      ' We will visiting the factory and help geting samples check and give reviews based on                             communication. and our team will put your projects on track till the product are ready to be                             produced from Prototype',
    csgmvo: ' Developing',
    ie98hv: 'Process',
    a9sghc: 'Design & Prototype',
    zztqn9:
      ' Prototype needs carefully checked and it needs several rounds of feedback',
    kbjhoe: ' Product Testing',
    jilwi4:
      'The prototypes requires a series of testing such as functional testing, Material lab testing etc.​  ',
    urjj9c: 'Tooling',
    '43jimm':
      'When it comes to final confirmation sample, some components required special mold, we need to control the tooling condition ',
    hdanvk: 'PP sample review',
    '5mucjv':
      ' In many cases, Pre-production sample needs to be carefully check for this is the last step before step into mass production ',
  },
  guide: {
    '6utg29': 'User Guide',
    '3proyr': 'Just a few steps to connect Minder Inspection system',
    r9gfva: 'Quick connect',
  },
  FQA: {
    '1ny4sh': 'Facts &',
    '0bdyn9': 'Questions',
    juuubr: 'What kind of service can I get from Minder ? ',
    j371ii: ' How to caculate the price?',
    m63h4i: ' How can I proceed the payment ?',
    '6a7k58': 'What is the key advantages can I expect here ?',
    cida7w: 'Can I cancel the Order in specific case ?',
    wptwf3:
      'Minder Provides services helping oversea buyers better control the goods import. Services like Quality inspection, Loading control, Vendor Audit, Product development. These are the key stages among the whole import & export  process. And they deserves a better control.',
    xzgjmq:
      'Minder services is caculated in M/D. The price will be different for different catagories. Our Account Manager will contact you to quote you the Price in M/D after the order is created in our system. You will be notified in Email the exact price for specific order',
    '3lr87o': 'You can Pay either in RMB or USD Payment methods: ',
    '3lr8733':
      '  1. Minder Plan 2. AliPay 3. WeChat Pay 4. PayPal 5. Bank Wire Transfer',

    grrsci:
      '1. Minder focused on the quality control system. we studied a lot of customers including trade agents and importers. We know what you care about your goods.',
    grrsci1:
      ' 2. With our integrated data collect system, our quality engineers get you the most important figures and these data will be shown clearly in our report which makes the report easy to read. ',
    grrsci2:
      ' 3. Minder provides high competitive price and you save more with our Plan.',
    grrsci3: ' ',

    rni8xf:
      'Yes, you can. If by any chance you input the incorrected order information, you can cancel the order. (Before the Due Date)',
    '68lado':
      'Yes, you can. If by any chance you input the incorrected order information, you can cancel the order. (Before the Due Date)',
  },
  contact: {
    '44bpko': "LET'S GET CNNECTED !",
    '8b7im3': 'Name',
    '6zh5n2': 'Email',
    ujdprn: 'Message',
    aes7hy: 'Submit',
  },
};
